type IconXProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
};

function IconX({ size = 20, color = '#909296', strokeWidth = 1.5 }: IconXProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconX.displayName = 'IconX';

export default IconX;
